import { render, staticRenderFns } from "./OrderNode.vue?vue&type=template&id=37f36a3e&scoped=true"
import script from "./OrderNode.vue?vue&type=script&lang=ts"
export * from "./OrderNode.vue?vue&type=script&lang=ts"
import style0 from "./OrderNode.vue?vue&type=style&index=0&id=37f36a3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f36a3e",
  null
  
)

export default component.exports